import React, { useState, useEffect } from "react";
import {
  sendVerificationEmailAPICall,
  verifyEmailCodeAPICall,
} from "../../env/APIManager";
import { AnimatePresence } from "framer-motion";
import ClipLoader from "react-spinners/ClipLoader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import AppBar from "../appbar/AppBar";
import ConfirmModal from "./ConfirmModal";
import styles from "./VerifyEmail.module.css";

const VerifyEmail = () => {
  const [sendEmailLoading, setSendEmailLoading] = useState(false);
  const [sendEmailError, setSendEmailError] = useState(false);
  const [email, setEmail] = useState("");
  const [codeInput, setCodeInput] = useState("");
  const [resendClicked, setResendClicked] = useState(false);
  const [verifyCodeLoading, setVerifyCodeLoading] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [verifyData, setVerifyData] = useState(null);

  let search = window.location.search;
  let params = new URLSearchParams(search);
  const token = params.get("token");
  const skuId = params.get("skuId");

  const errorToastOptions = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  useEffect(() => {
    sendVerificationEmail();
  }, []);

  const sendVerificationEmail = async () => {
    setSendEmailLoading(true);
    const sendEmailRes = await sendVerificationEmailAPICall(token);
    if (sendEmailRes.code !== "SUCCESS") {
      setSendEmailError(true);
    } else {
      setEmail(sendEmailRes.email);
    }
    setSendEmailLoading(false);
  };

  const handleCodeInputChange = (e) => {
    if (!isNaN(e.target.value)) {
      setCodeInput(e.target.value.trim());
    }
  };

  const handleVerifyButtonClick = async () => {
    if (codeInput.length !== 6) {
      toast.error("Code must be 6 digits long.", errorToastOptions);
    } else {
      setVerifyCodeLoading(true);
      const verifyCodeRes = await verifyEmailCodeAPICall(
        token,
        codeInput,
        skuId
      );
      if (!verifyCodeRes) {
        toast.error(
          "There was a problem verifying your email. Please go back and try again.",
          errorToastOptions
        );
      } else if (verifyCodeRes.code !== "SUCCESS") {
        toast.error(verifyCodeRes.message, errorToastOptions);
      } else {
        setVerifyData(verifyCodeRes.data);
        setConfirmModalOpen(true);
      }
      setVerifyCodeLoading(false);
    }
  };

  const handleResendButtonClick = async () => {
    setResendClicked(true);
    sendVerificationEmail();
  };

  return (
    <section>
      {verifyCodeLoading && (
        <div className={styles["verify-code-loading"]}>
          <ClipLoader size={100} color="var(--primary-color)" />
        </div>
      )}
      {sendEmailLoading ? (
        <div className={styles["send-email-loading"]}>
          <ClipLoader size={100} color="var(--primary-color)" />
        </div>
      ) : (
        <>
          <ToastContainer />
          <AnimatePresence
            initial={false}
            exitBeforeEnter={true}
            onExitComplete={() => {
              window.scrollTo(0, 0);
              document.body.style.overflow = "unset";
            }}
          >
            {confirmModalOpen && <ConfirmModal verifyData={verifyData} />}
          </AnimatePresence>
          <AppBar />
          <div className={`${styles["verify-email-container"]} d-flex flex-column`}>
            {sendEmailError ? (
              <p className={styles["verify-text"]}>
                There was a problem sending the verification email. Please go
                back and try again.
              </p>
            ) : (
              <>
                <p className={styles["verify-text"]}>
                A verification code was sent to your email:<br/> {email}
                </p>
                <input
                  className={styles["code-input"]}
                  type="text"
                  inputMode="numeric"
                  maxLength={6}
                  value={codeInput}
                  onChange={handleCodeInputChange}
                />
                <div className="d-flex flex-column mt-auto w-100">
                  {resendClicked ? (
                    <p className={styles["code-sent-text"]}>Code Sent</p>
                  ) : (
                    <p className={`${styles["verify-text"]} text-center`}>Please check your email and enter the code.<br/>
                      Didn't get it? <span className={styles["link"]} onClick={handleResendButtonClick}>Resend Code</span>
                    </p>
                  )}
                  <button
                    className={`${styles["verify-button"]} rounded-pill`}
                    onClick={handleVerifyButtonClick}
                  >
                    Confirm
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </section>
  );
};

export default VerifyEmail;
